// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nrt: CountryValidator<"AD"> = createValidator(
  "ad.nrt",
  0,
);

export default nrt;
export const compact = nrt.compact;
export const format = nrt.format;
export const validate = nrt.validate;
export const generate = (): string =>
  nrt.generate?.() ??
  (() => {
    throw new Error(
      "Validator ad.nrt cannot generate values",
    );
  })();
